import React, {Component} from 'react'

import Avatar from '@atlaskit/avatar';
import {
  CommentAuthor,
  CommentTime,
  CommentAction,
  CommentEdited,
} from '@atlaskit/comment';
import { ReactRenderer } from '@atlaskit/renderer';
import { Collapsible, WikiEditor, Container, MentionProvider } from '../../components/index'
import config from '../../config'

const dateOptions = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit' }

export default class CollapsibleComment extends Component {
    constructor (props, ...args) {
        super(props, ...args)
        this.state = {
          isOpen: true,
          edit: false,
          editingComment: false
        }
      }
    
      handleTrigger = (edit) => {
        this.setState( edit ? { isOpen: true } : {isOpen: !this.state.isOpen})
      }

      handleEdit = (e) => {
          let { onEditing } = this.props
          onEditing()
          this.state.edit === false ? e.stopPropagation() : null          
          this.setState({edit: !this.state.edit})          
      }

      handleUpdate = (values) => {
        let { onUpdate, comment } = this.props
        comment.body = values
        onUpdate(comment)
        this.handleEdit()
      }
      
      componentWillReceiveProps (nextProps) {
        if (nextProps.editingComment != this.props.editingComment) return
        this.setState({ editingComment: nextProps.editingComment })
      } 
    
      render () {
        let { comment, user, editingComment } = this.props        
        let created = new Date(comment.created)
        let mentionProvider = MentionProvider(config.mentionsIssue)
        return (
            <Container className='comment-container'>
                <div className='comment-outer'>
                    <Collapsible open={this.state.isOpen} handleTriggerClick={() => this.handleTrigger(this.state.edit)}                
                        trigger= {
                            <div className='comment-inner'>
                                <div className='comment-header'>
                                    <div className='comment-header-main'>
                                        <div className='comment-avatar-container'>
                                            <Avatar className='comment-avatar' appearance='square' size="small"
                                            src={comment.author.avatarUrls ? comment.author.avatarUrls['48x48'] : null}  />
                                        </div>
                                        <div className='comment-header-main-contents'>
                                            <CommentAuthor>{comment.author.displayName}</CommentAuthor>
                                        </div>
                                        {comment.updated != comment.created ?
                                            <div className='comment-header-main-contents'>
                                                <CommentEdited>Edited</CommentEdited>
                                            </div> 
                                        : null}
                                        <div className='comment-header-main-contents'><CommentTime>{created.toLocaleDateString('en-US', dateOptions)}</CommentTime></div>
                                    </div>
                                    {
                                        user.email == comment.author.emailAddress ?
                                            editingComment || this.state.edit ?
                                                null :
                                                    <CommentAction className='btn icon-solo comment-header-right' onClick={this.handleEdit}>
                                                        <i className='fa fa-pencil' />
                                                    </CommentAction>
                                            : null
                                    }
                                </div>
                            </div>
                        }>
                        <div className='comment-content'>
                            {
                                this.state.edit ?                                
                                <WikiEditor 
                                    key={comment.id}
                                    onSave={this.handleUpdate}
                                    onCancel={this.handleEdit} 
                                    value={comment.body}
                                    mentionProvider={mentionProvider}
                                />
                                : <ReactRenderer document={comment.body} />                                
                            }
                        </div>
                    </Collapsible>
                </div>
            </Container>
        )
      }
}


// WEBPACK FOOTER //
// ./client/src/serviceDesk/components/CollapsibleComment.js